import { useState, useEffect } from "react"
import { Typography } from "antd"
import {
  BarChartOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography

const Header = () => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])
  return (
    <div style={{ marginBottom: "24px" }}>
        <Title level={1}>
          <BarChartOutlined style={{ marginRight: "12px", color: "#1890ff" }} />
          Operations Dashboard
        </Title>
        <Text type="secondary">
          Live operations intelligence and execution tracking • Last updated: {currentTime.toLocaleTimeString()}
        </Text>
      </div>
  )
}

export default Header